import { render, staticRenderFns } from "./menu_parcelles.vue?vue&type=template&id=820895ee"
import script from "./menu_parcelles.js?vue&type=script&lang=js&external"
export * from "./menu_parcelles.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports